import { COLORS } from '@constants';
import { Card } from 'antd';
import styled, { css } from 'styled-components';

export const StyledWrapper = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const StyledCard = styled(Card)`
    & {
        width: 100%;
    }

    & .ant-card-head {
        min-height: auto;
        padding-top: 24px;

        ${({ $isHomePage }) =>
            !$isHomePage
                ? css`
                      padding-bottom: 0;
                      border: none;

                      &:after {
                          border-bottom: 1px solid ${COLORS.$gray15Black};
                          padding-top: 24px;
                      }
                  `
                : ''}
    }

    & .ant-card-body {
        display: flex;
        justify-content: center;
        align-items: center;
        box-sizing: content-box;
        height: 168px;
    }
`;
